/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $BulkCreateEmployeeResponse = {
    properties: {
        totalRequested: {
    type: 'number',
    isRequired: true,
},
        errors: {
    type: 'array',
    contains: {
    type: 'string',
},
    isRequired: true,
},
        createdEmployeeIds: {
    type: 'array',
    contains: {
    type: 'number',
},
    isRequired: true,
},
    },
};